import { MARKET_PAGE_SIZE } from '@game/constants';
import type { ClientInventoryItem, ClientMarketBase, ClientMarketResults } from '@game/shared-types';

export interface MarketState {
  marketOrders: ClientMarketResults;
  marketListings: ClientMarketResults;
  ownMarketEntries: ClientMarketBase[];
  marketItems: ClientInventoryItem[];
  searchTerm: string;
  buyOrdersPagination: { pageIndex: number; pageSize: number };
  sellOrdersPagination: { pageIndex: number; pageSize: number };
}

export const marketDefault: MarketState = {
  marketOrders: { totalCount: 0, entries: [] },
  marketListings: { totalCount: 0, entries: [] },
  ownMarketEntries: [],
  marketItems: [],
  searchTerm: '',
  buyOrdersPagination: { pageIndex: 0, pageSize: MARKET_PAGE_SIZE },
  sellOrdersPagination: { pageIndex: 0, pageSize: MARKET_PAGE_SIZE },
};
